import React from "react";
import { Link } from "react-router-dom";
import conectaLogo_footer from "../../assets/generales/conecta-peru-footer.svg";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-4">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-md-4 mb-3">
            <Link to="/">
              <img
                src={conectaLogo_footer}
                alt="Logo"
                className="mb-2 logo-footer"
              />
            </Link>

            <div className="titulo_conectandoemociones">
              Conectando emociones.
              <br />
              De todo y para todos
            </div>
            <div className="mt-2 d-flex gap-2">
              <a
                href="https://www.instagram.com/"
                target="_black"
                className="footer-social footer-social-instagram"
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/"
                target="_black"
                className="footer-social footer-social-facebook"
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="fw-bold mb-2 titulo_conectando">CONOCER MÁS</div>
            <Link to="/conocenos" className="titulo_conectandoemociones">
              Sobre nosotros
            </Link>
            <br />
            <Link to="/conocenos#mision" className="titulo_conectandoemociones">
              Misión
            </Link>
            <br />
            <Link to="/conocenos#vision" className="titulo_conectandoemociones">
              Visión
            </Link>
          </div>
          <div className="col-md-4 mb-3">
            <div className="fw-bold mb-2 titulo_conectando">CONTÁCTANOS</div>
            <div className="titulo_conectandoemociones">
              Administradores
              <br />
              usuario1@conectate-peru.com
            </div>
            <div className="titulo_conectandoemociones">
              Usuario1
              <br />
              user@conectate-peru.com
            </div>
            <div className="titulo_conectandoemociones">+01 234 567 88</div>
          </div>
        </div>
        <div className="text-center mt-3 small titulo_conectandoemociones">
          Conéctate Perú | Copyright © 2025. Derechos reservados
        </div>
      </div>
    </footer>
  );
};

export default Footer;
